import _regenerator from "/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import request from "@/routes/api/api_conextion";
import axios from "axios";
// eslint-disable-next-line no-unused-vars
import { getFromLocal, saveInLocal } from "@/commons/utils/storage";
function getResourece(resource) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return new Promise(function (resolve) {
    setTimeout(function () {
      request({
        url: resource,
        method: "get",
        params: params
      }).then(function (request) {
        // saveInLocal(resource, request)
        resolve(request);
      });
    }, 1000);
  });
}
export function getEstadoCivil() {
  return _getEstadoCivil.apply(this, arguments);
}
function _getEstadoCivil() {
  _getEstadoCivil = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          return _context.a(2, getResourece("/marital-status"));
      }
    }, _callee);
  }));
  return _getEstadoCivil.apply(this, arguments);
}
export function getSucursales(_x) {
  return _getSucursales.apply(this, arguments);
}
function _getSucursales() {
  _getSucursales = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(id) {
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          return _context2.a(2, getResourece("/sucursales/" + id));
      }
    }, _callee2);
  }));
  return _getSucursales.apply(this, arguments);
}
export function getTipoViviendas() {
  return _getTipoViviendas.apply(this, arguments);
}
function _getTipoViviendas() {
  _getTipoViviendas = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          return _context3.a(2, getResourece("/properties"));
      }
    }, _callee3);
  }));
  return _getTipoViviendas.apply(this, arguments);
}
export function getEstudios() {
  return _getEstudios.apply(this, arguments);
}
function _getEstudios() {
  _getEstudios = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          return _context4.a(2, getResourece("/studies"));
      }
    }, _callee4);
  }));
  return _getEstudios.apply(this, arguments);
}
export function getFormasDeEnterarse() {
  return _getFormasDeEnterarse.apply(this, arguments);
}
function _getFormasDeEnterarse() {
  _getFormasDeEnterarse = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          return _context5.a(2, getResourece("/find-out"));
      }
    }, _callee5);
  }));
  return _getFormasDeEnterarse.apply(this, arguments);
}
export function getRelacionesLaborales() {
  return _getRelacionesLaborales.apply(this, arguments);
}
function _getRelacionesLaborales() {
  _getRelacionesLaborales = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          return _context6.a(2, getResourece("/employment-relations"));
      }
    }, _callee6);
  }));
  return _getRelacionesLaborales.apply(this, arguments);
}
export function getCoinTypes() {
  return _getCoinTypes.apply(this, arguments);
}
function _getCoinTypes() {
  _getCoinTypes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
    return _regenerator().w(function (_context7) {
      while (1) switch (_context7.n) {
        case 0:
          return _context7.a(2, getResourece("/coinTypes"));
      }
    }, _callee7);
  }));
  return _getCoinTypes.apply(this, arguments);
}
export function getSelds() {
  return _getSelds.apply(this, arguments);
}
function _getSelds() {
  _getSelds = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
    return _regenerator().w(function (_context8) {
      while (1) switch (_context8.n) {
        case 0:
          return _context8.a(2, getResourece("/workers"));
      }
    }, _callee8);
  }));
  return _getSelds.apply(this, arguments);
}
export function getVentasTop() {
  return _getVentasTop.apply(this, arguments);
}
function _getVentasTop() {
  _getVentasTop = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
    return _regenerator().w(function (_context9) {
      while (1) switch (_context9.n) {
        case 0:
          return _context9.a(2, getResourece("/ventasTop"));
      }
    }, _callee9);
  }));
  return _getVentasTop.apply(this, arguments);
}
export function getDepartamentos() {
  return _getDepartamentos.apply(this, arguments);
}
function _getDepartamentos() {
  _getDepartamentos = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
    return _regenerator().w(function (_context0) {
      while (1) switch (_context0.n) {
        case 0:
          return _context0.a(2, getResourece("/departamentos"));
      }
    }, _callee0);
  }));
  return _getDepartamentos.apply(this, arguments);
}
export function getBancos() {
  return _getBancos.apply(this, arguments);
}
function _getBancos() {
  _getBancos = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
    return _regenerator().w(function (_context1) {
      while (1) switch (_context1.n) {
        case 0:
          return _context1.a(2, getResourece("/bancos"));
      }
    }, _callee1);
  }));
  return _getBancos.apply(this, arguments);
}
export function getRubros() {
  return _getRubros.apply(this, arguments);
}
function _getRubros() {
  _getRubros = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
    return _regenerator().w(function (_context10) {
      while (1) switch (_context10.n) {
        case 0:
          return _context10.a(2, getResourece("/rubros"));
      }
    }, _callee10);
  }));
  return _getRubros.apply(this, arguments);
}
export function getMunicipios(_x2) {
  return _getMunicipios.apply(this, arguments);
}
function _getMunicipios() {
  _getMunicipios = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(params) {
    return _regenerator().w(function (_context11) {
      while (1) switch (_context11.n) {
        case 0:
          return _context11.a(2, getResourece("/getMunicipios/" + params));
      }
    }, _callee11);
  }));
  return _getMunicipios.apply(this, arguments);
}
export function getLocalidad(_x3) {
  return _getLocalidad.apply(this, arguments);
}
function _getLocalidad() {
  _getLocalidad = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(params) {
    return _regenerator().w(function (_context12) {
      while (1) switch (_context12.n) {
        case 0:
          return _context12.a(2, getResourece("/getLocalidad/" + params));
      }
    }, _callee12);
  }));
  return _getLocalidad.apply(this, arguments);
}
export function getMunicipiosByName(_x4) {
  return _getMunicipiosByName.apply(this, arguments);
}
function _getMunicipiosByName() {
  _getMunicipiosByName = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(params) {
    return _regenerator().w(function (_context13) {
      while (1) switch (_context13.n) {
        case 0:
          return _context13.a(2, getResourece("/municipio/" + params));
      }
    }, _callee13);
  }));
  return _getMunicipiosByName.apply(this, arguments);
}
export function getLocalidadByName(_x5) {
  return _getLocalidadByName.apply(this, arguments);
}
function _getLocalidadByName() {
  _getLocalidadByName = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(params) {
    return _regenerator().w(function (_context14) {
      while (1) switch (_context14.n) {
        case 0:
          return _context14.a(2, getResourece("/localidad/" + params));
      }
    }, _callee14);
  }));
  return _getLocalidadByName.apply(this, arguments);
}
export function getDepartamentoByName(_x6) {
  return _getDepartamentoByName.apply(this, arguments);
}
function _getDepartamentoByName() {
  _getDepartamentoByName = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(params) {
    return _regenerator().w(function (_context15) {
      while (1) switch (_context15.n) {
        case 0:
          return _context15.a(2, getResourece("/departamento/" + params));
      }
    }, _callee15);
  }));
  return _getDepartamentoByName.apply(this, arguments);
}
export function getDocumentsType(_x7) {
  return _getDocumentsType.apply(this, arguments);
}
function _getDocumentsType() {
  _getDocumentsType = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(params) {
    var active,
      _args16 = arguments;
    return _regenerator().w(function (_context16) {
      while (1) switch (_context16.n) {
        case 0:
          active = _args16.length > 1 && _args16[1] !== undefined ? _args16[1] : true;
          return _context16.a(2, getResourece("/documents/" + params + "/" + active));
      }
    }, _callee16);
  }));
  return _getDocumentsType.apply(this, arguments);
}
export function getPaises(_x8) {
  return _getPaises.apply(this, arguments);
}
function _getPaises() {
  _getPaises = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(params) {
    return _regenerator().w(function (_context17) {
      while (1) switch (_context17.n) {
        case 0:
          return _context17.a(2, getResourece("/getPaises", params));
      }
    }, _callee17);
  }));
  return _getPaises.apply(this, arguments);
}
export function getPais(_x9) {
  return _getPais.apply(this, arguments);
}
function _getPais() {
  _getPais = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(id) {
    return _regenerator().w(function (_context18) {
      while (1) switch (_context18.n) {
        case 0:
          return _context18.a(2, getResourece("/getPaises/" + id));
      }
    }, _callee18);
  }));
  return _getPais.apply(this, arguments);
}
export function getDirectionConfig() {
  return _getDirectionConfig.apply(this, arguments);
}
function _getDirectionConfig() {
  _getDirectionConfig = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19() {
    return _regenerator().w(function (_context19) {
      while (1) switch (_context19.n) {
        case 0:
          return _context19.a(2, getResourece("/direction/config"));
      }
    }, _callee19);
  }));
  return _getDirectionConfig.apply(this, arguments);
}
export function getFormasPago() {
  return _getFormasPago.apply(this, arguments);
}
function _getFormasPago() {
  _getFormasPago = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20() {
    return _regenerator().w(function (_context20) {
      while (1) switch (_context20.n) {
        case 0:
          return _context20.a(2, getResourece("/getFormasPago"));
      }
    }, _callee20);
  }));
  return _getFormasPago.apply(this, arguments);
}
export function getDocIde(_x0) {
  return _getDocIde.apply(this, arguments);
}
function _getDocIde() {
  _getDocIde = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21(id) {
    return _regenerator().w(function (_context21) {
      while (1) switch (_context21.n) {
        case 0:
          return _context21.a(2, getResourece("/getdocide/" + id));
      }
    }, _callee21);
  }));
  return _getDocIde.apply(this, arguments);
}
export function getInstantorSettings() {
  return _getInstantorSettings.apply(this, arguments);
}
function _getInstantorSettings() {
  _getInstantorSettings = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22() {
    return _regenerator().w(function (_context22) {
      while (1) switch (_context22.n) {
        case 0:
          return _context22.a(2, getResourece("/instantor/config"));
      }
    }, _callee22);
  }));
  return _getInstantorSettings.apply(this, arguments);
}
export function getRequisitos(_x1) {
  return _getRequisitos.apply(this, arguments);
}
function _getRequisitos() {
  _getRequisitos = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23(id) {
    return _regenerator().w(function (_context23) {
      while (1) switch (_context23.n) {
        case 0:
          return _context23.a(2, getResourece("/requisitosgarante/" + id));
      }
    }, _callee23);
  }));
  return _getRequisitos.apply(this, arguments);
}
export function validateContact(_x10, _x11, _x12) {
  return _validateContact.apply(this, arguments);
}
function _validateContact() {
  _validateContact = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24(email, phone, document) {
    return _regenerator().w(function (_context24) {
      while (1) switch (_context24.n) {
        case 0:
          return _context24.a(2, getResourece("/validarcontacto?" + "email=" + email + "&phone=" + phone + "&document=" + document));
      }
    }, _callee24);
  }));
  return _validateContact.apply(this, arguments);
}
export function getIp() {
  return _getIp.apply(this, arguments);
}
function _getIp() {
  _getIp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee25() {
    return _regenerator().w(function (_context25) {
      while (1) switch (_context25.n) {
        case 0:
          return _context25.a(2, axios.create({
            baseURL: process.env.VUE_APP_IPL_URL,
            // url = base url + request url
            // withCredentials: true, // send cookies when cross-domain requests
            timeout: 5000 // request timeout
          }).get("/json"));
      }
    }, _callee25);
  }));
  return _getIp.apply(this, arguments);
}
export function getMotivoRechazo(_x13) {
  return _getMotivoRechazo.apply(this, arguments);
}
function _getMotivoRechazo() {
  _getMotivoRechazo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee26(loan) {
    var ruta;
    return _regenerator().w(function (_context26) {
      while (1) switch (_context26.n) {
        case 0:
          ruta = loan ? "/getmotivorechazo/" + loan : "/getmotivorechazo";
          return _context26.a(2, getResourece(ruta));
      }
    }, _callee26);
  }));
  return _getMotivoRechazo.apply(this, arguments);
}
export function validateNames(_x14, _x15, _x16) {
  return _validateNames.apply(this, arguments);
}
function _validateNames() {
  _validateNames = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee27(type, names, document) {
    return _regenerator().w(function (_context27) {
      while (1) switch (_context27.n) {
        case 0:
          return _context27.a(2, getResourece("/validarnames?" + "type=" + type + "&names=" + names + "&document=" + document));
      }
    }, _callee27);
  }));
  return _validateNames.apply(this, arguments);
}
export function getTextProduct(_x17) {
  return _getTextProduct.apply(this, arguments);
}
function _getTextProduct() {
  _getTextProduct = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee28(params) {
    return _regenerator().w(function (_context28) {
      while (1) switch (_context28.n) {
        case 0:
          return _context28.a(2, getResourece("/getTextProduct/" + params));
      }
    }, _callee28);
  }));
  return _getTextProduct.apply(this, arguments);
}
export function getEmpresasOferentes() {
  return _getEmpresasOferentes.apply(this, arguments);
}
function _getEmpresasOferentes() {
  _getEmpresasOferentes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee29() {
    return _regenerator().w(function (_context29) {
      while (1) switch (_context29.n) {
        case 0:
          return _context29.a(2, getResourece("/getEmpresasOferentes"));
      }
    }, _callee29);
  }));
  return _getEmpresasOferentes.apply(this, arguments);
}
export function getMensajeFinal(_x18) {
  return _getMensajeFinal.apply(this, arguments);
}
function _getMensajeFinal() {
  _getMensajeFinal = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee30(params) {
    return _regenerator().w(function (_context30) {
      while (1) switch (_context30.n) {
        case 0:
          return _context30.a(2, getResourece("/getMensajeFinal/" + params));
      }
    }, _callee30);
  }));
  return _getMensajeFinal.apply(this, arguments);
}
export function getAgrupacion1() {
  return _getAgrupacion.apply(this, arguments);
}
function _getAgrupacion() {
  _getAgrupacion = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee31() {
    return _regenerator().w(function (_context31) {
      while (1) switch (_context31.n) {
        case 0:
          return _context31.a(2, getResourece("/agrupacion1"));
      }
    }, _callee31);
  }));
  return _getAgrupacion.apply(this, arguments);
}
export function getAgrupacion2(_x19) {
  return _getAgrupacion2.apply(this, arguments);
}
function _getAgrupacion2() {
  _getAgrupacion2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee32(params) {
    return _regenerator().w(function (_context32) {
      while (1) switch (_context32.n) {
        case 0:
          return _context32.a(2, getResourece("/agrupacion2/" + params));
      }
    }, _callee32);
  }));
  return _getAgrupacion2.apply(this, arguments);
}
export function getAgrupacion3(_x20) {
  return _getAgrupacion3.apply(this, arguments);
}
function _getAgrupacion3() {
  _getAgrupacion3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee33(params) {
    return _regenerator().w(function (_context33) {
      while (1) switch (_context33.n) {
        case 0:
          return _context33.a(2, getResourece("/agrupacion3/" + params));
      }
    }, _callee33);
  }));
  return _getAgrupacion3.apply(this, arguments);
}